const config = {
    googleClientId: '1018620538862-rkkt7sr1evpc3g6gp38ctfvcbdudq7k3.apps.googleusercontent.com',
    redirectUri: import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3000/adminlogin',
    apiBaseUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    tokenRefreshInterval: 50 * 60 * 1000, // 50 minutes in milliseconds
};

export default config;
